export const environment = {
    environment: "development",
    apiDynamic: false,
    api: "https://api.dev.jaak.ai",
    tayrona: "https://tayrona.dev.jaak.ai",
    urlWeb: "https://kyc.dev.jaak.ai",
    urlDashboard: "https://platform.dev.jaak.ai",
    apiOneToOne: "https://facade-1to1-http-635t26xtnq-uc.a.run.app",
    googleAnalyticsKey: "G-K1W2S53PEJ",
    logging: {
        enable: false
    },
    blinkKey: {
        default: "",
    },
    sentry: {
        enable: false,
        dsn: "",
        tracesSampleRate: 0,
        tracePropagationTargets: [],
        replaysSessionSampleRate: 0,
        environment: "development",
    },
    firebaseConfig: {
        apiKey: "",
        authDomain: "",
        projectId: "",
        storageBucket: "",
        messagingSenderId: "",
        appId: "",
        measurementId: "",
    },
    license: {
        enabled: true,
        endpoint: "/api/v1/license/validate",
        tracing: {
            enabled: true,
            sampled: true,
        },
        defaultMetadata: {
            sdk_version: "1.0.1",
            app_id: "jaak-kyc-web",
            origin: "web",
            product: "kyc"
        },
        validation: {
            pattern: /^[A-Z0-9]{3}-[A-Z0-9]{3}-[A-Z0-9]{3}-[A-Z0-9]{3}$/i,
            minLength: 15,
            maxLength: 50,
        },
        urlParams: ["license", "lic"],
    },
    openTelemetry: {
        enabled: true,
        endpoint: "https://collector.jaak.ai/v1/traces",
        serviceName: "jaak-kyc-web",
        resourceAttributes: {
            "service.name": "jaak-kyc-web",
            "service.version": "6.25.0-dev.24",
            "deployment.environment": "development",
            "customer.id": "",
        },
        sampling: {
            tracesSampleRate: 1.0,
        },
        propagateTraceHeaderCorsUrls: [
            "https://api.dev.jaak.ai",
            /https:\/\/.*\.jaak\.ai/,
        ],
        instrumentation: {
            fetch: false,
            xhr: false,
            documentLoad: true,
            userInteraction: {
                enabled: false,
                eventNames: ["click", "submit", "change"],
            },
        },
        exporter: {
            batchSize: 512,
            maxQueueSize: 2048,
            scheduledDelayMillis: 5000,
            exportTimeoutMillis: 30000,
        },
    },
};
